// extracted by mini-css-extract-plugin
export default {"PendingFile":"PendingFiles_PendingFile__VRFOq","PendingFileRemove":"PendingFiles_PendingFileRemove__oibzK"};